import React from 'react';
import ReactModal from 'react-modal';
import * as S from './Modal.styles.js';
import CloseIcon from '../../assets/images/icons-cerrar-24-px.svg';
import Icon from '../Icon/Icon.js';

const widthBySize = {
  md: '510px',
};

const Modal = ({
  children,
  onDismiss,
  isOpen,
  size,
  showOverlay = true,
  shouldCloseOnOverlayClick = true,
  modalMargins,
  hasCloseIcon = true,
}) => {
  const sizeMd = size === 'md';
  const modalMarginSize = modalMargins || '4% auto';
  return (
    <ReactModal
      isOpen={isOpen}
      className={`modal-size-${size}`}
      onRequestClose={() => onDismiss && onDismiss(false)}
      style={{
        overlay: {
          background: showOverlay ? 'rgba(0,0,0,0.65)' : 'transparent',
          zIndex: 1,
        },
        content: {
          width: sizeMd && widthBySize[size],
          margin: sizeMd ? '0 auto' : '0 16px',
        },
      }}
      shouldFocusAfterRender={false}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      <S.ModalWrapper
        sizeMd={sizeMd}
        modalMarginSize={modalMarginSize}
        data-testid='modal-wrapper'
      >
        {hasCloseIcon && (
          <S.ModalIconBase>
            {onDismiss &&
              (sizeMd ? (
                <S.IconMd onClick={onDismiss} src={CloseIcon} />
              ) : (
                <S.IconWrapper>
                  <Icon
                    onClick={onDismiss}
                    width={24}
                    height={24}
                    cursor='pointer'
                    name='cancel_outline'
                  />
                </S.IconWrapper>
              ))}
          </S.ModalIconBase>
        )}
        <S.ModalContent sizeMd={sizeMd}>{children}</S.ModalContent>
      </S.ModalWrapper>
    </ReactModal>
  );
};

export default Modal;
